<div class="title-row field-group mt-2" fxLayout="row" fxLayoutAlign="space-between center">
  <main class="title-simple-steps">
    <h1>{{ titleKey | translate }}</h1>
    <p *ngIf="descriptionKey" class="step-description">
      {{ descriptionKey | translate }}
    </p>
  </main>
</div>

<form
  class="sign-up-form tax-setup-form"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <div class="mb-[32px]">
    <mat-label class="label">
      {{ 'DoYouHaveTax' | translate }}
    </mat-label>
    <mat-radio-group formControlName="HaveTax" color="primary">
      <mat-radio-button [value]="true">{{ 'Yes' | translate }}</mat-radio-button>
      <mat-radio-button [value]="false" class="ml-2">{{ 'No' | translate }}</mat-radio-button>
    </mat-radio-group>
  </div>

  <div *ngIf="form.get('HaveTax')?.value === true" class="mb-[10px] tax-percentage-wrap">
    <mat-label class="label">{{ 'Tax_Percentage' | translate }}</mat-label>
    <mat-form-field appearance="outline">
      <input
        matInput
        type="number"
        formControlName="TaxRate"
        placeholder="0"
        appNumberOnly
      />
      <span matSuffix><i class="fa-solid fa-percent" style="margin-inline-end: 10px;"></i></span>
      <mat-error>
        <app-error-form
          [name]="'Tax_Percentage' | translate"
          [control]="form.controls['TaxRate']"
          [max]="60"
          [min]="1"
        ></app-error-form>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="field-group" *ngIf="form.get('HaveTax')?.value === true">
    <mat-label class="label">{{ 'Price_include_taxes' | translate }}</mat-label>
    <mat-radio-group formControlName="PriceIncludeTax" color="primary">
      <mat-radio-button [value]="true">{{ 'Yes' | translate }}</mat-radio-button>
      <mat-radio-button [value]="false" class="ml-2">{{ 'No' | translate }}</mat-radio-button>
    </mat-radio-group>
  </div>

  <div
    class="actions-buttons"
    *ngIf="showActions"
    fxLayout="row"
    fxLayoutAlign="stretch center"
  >
    <button
      type="button"
      class="action-btn prev-btn"
      fxFlex="1 1 0"
      (click)="onCancelClick()"
    >
      {{ cancelLabelKey | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      class="action-btn submit-btn"
      fxFlex="1 1 0"
      type="submit"
      [disabled]="!canConfirm || loading"
    >
      {{ submitLabelKey | translate }}
      <span class="btn-spinner-icon" *ngIf="loading"></span>
    </button>
  </div>
</form>
